import { state } from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default function extendCheckout (storeCheckout) {
  storeCheckout.state = { ...storeCheckout.state, ...state(storeCheckout) }
  storeCheckout.getters = { ...storeCheckout.getters, ...getters }
  storeCheckout.mutations = { ...storeCheckout.mutations, ...mutations }
  storeCheckout.actions = { ...storeCheckout.actions, ...actions }
  return storeCheckout
}
